module.exports = __webpack_public_path__ + "img/braces.1d04069b.svg";